module.exports = __webpack_public_path__ + "static/media/danger-icon.b98aadc0.svg";